export class BuyPreInvoiceImportRequestModal {
  public constructor() {
    this.drugs = [];
  }

  public PreInvoiceId?: string;
  public preInvoiceDate?: any;
  public receiveDate: any;
  public description?: string;
  public companyId?: string;
  public sellerId?: string;
  
  public preInvoiceDateMessage?: string;
  public receiveDateMessage: string | undefined;
  public companyIdMessage?: string;
  public sellerIdMessage?: string;

  public CompanyName?: string;

  public drugs: BuyPreInvoiceImportRequestDrugModel[];
}

export class BuyPreInvoiceImportRequestDrugModel {
  public constructor() {
    this.count=0;
  }

  public drugId?: string;
  public count: number;
  public drugName?: string;
}
